﻿import _ from "underscore";
import angular from "angular";
import moment from "moment";
import { QuickShopServices } from "./quickshop-services";
import { QuickshopControllers } from "./quickshop-controllers";
import "./libs/angular-route";
import "./libs/ui-bootstrap-custom-tpls-0.10.0";
import "./libs/ui-utils";
import "../../node_modules/angular-i18n/angular-locale_sv-se.js"
import datePicker from "angular-datepicker";

var quickShopApp = angular.module('QuickShop', ['ngRoute', 'ui.bootstrap', 'ui.utils', 'datePicker']);

quickShopApp.config(['$locationProvider', '$httpProvider', '$routeProvider', function ($locationProvider, $httpProvider, $routeProvider) {
	$locationProvider.hashPrefix('!');

	$httpProvider.defaults.headers.common["Accept-Language"] = document.documentElement.lang === "en" ? "en-US" : "sv-SE";
	$httpProvider.interceptors.push([
		'$q', function ($q) {
			return {
				responseError: function (rejection) {
					if (rejection.status === 401) {
						alert('Din session har gått ut.\r\nVar vänlig logga in igen.\r\n' + rejection.data);
						window.location = window.QuickShopSettings.logoutUrl;
						return {}; //Tomt objekt för att hindra felet att propageras vidare.
					}

					return $q.reject(rejection);
				}
			};
		}
	]);


	if (window.QuickShopSettings) {
	    $httpProvider.defaults.headers.common["X-AuthToken"] = window.QuickShopSettings.token;
	}

	$routeProvider.when('/kvitto', {
		templateUrl: 'receipt',
		controller: 'ShowReservationCtrl'
	}).when('/lista-bokningar', {
		templateUrl: 'reservationList',
		controller: 'ReservationListCtrl'
	}).when('/visa-bokning/:reservationId', {
		templateUrl: 'receipt',
		controller: 'ShowReservationCtrl'
	}).when('/sok-bokning', {
		templateUrl: 'search',
		controller: 'SearchReservationCtrl'
	}).when('/installningar', {
		templateUrl: 'settings',
		controller: 'SettingsCtrl'
	}).when('/rapporter/detaljerad', {
		templateUrl: 'detailedReport',
		controller: 'DetailedReportCtrl'
	}).when('/rapporter', {
		templateUrl: 'summaryReport',
		controller: 'SummaryReportCtrl'
	}).otherwise({
		templateUrl: 'quickshop',
		controller: 'QuickShopCtrl'
	});
}]);

var services = QuickShopServices();
var controllers = QuickshopControllers();

quickShopApp
	.controller('QuickShopCtrl', ['$scope', 'reservationService', 'cartService', 'cacheService', 'settingsService', controllers.quickShopCtrl])
    .controller('CartCtrl', ['$scope', '$location', '$modal', '$window', 'reservationService', 'cartService', controllers.cartCtrl])
	.controller('ReservationListCtrl', ['$scope', '$location', 'reservationService', 'appVariables', controllers.reservationListCtrl])
	.controller('SearchReservationCtrl', ['$scope', '$location', 'reservationService', 'appVariables', controllers.searchReservationCtrl])
	.controller('ShowReservationCtrl', ['$scope', '$window', '$document', '$timeout', '$location', '$modal', '$routeParams', 'reservationService', 'settingsService', controllers.showReservationCtrl])
	.controller('SettingsCtrl', ['$scope', '$timeout', 'settingsService', controllers.settingsCtrl])
	.controller('SummaryReportCtrl', ['$scope', '$window', '$location', '$timeout', 'reportService', controllers.summaryReportCtrl])
	.controller('DetailedReportCtrl', ['$scope', '$window', '$location', 'reportService', controllers.detailedReportCtrl])
	.factory('reservationService', ['$http', 'cacheService', services.reservationService])
	.factory('reportService', ['$http', services.reportService])
	.factory('cartService', ['settingsService', services.cartService])
	.factory('cacheService', [services.cacheService])
	.factory('settingsService', ['$window', 'cacheService', services.settingsService])
	.value('appVariables', {})
	.directive('ngKeepScroll', ['$timeout', function ($timeout) {
		return function (scope, element, attrs) {

			//Wait for data loaded event if provided
			if (attrs.ngDataLoadedEvent)
				scope.$on(attrs.ngDataLoadedEvent, restorePosition);
			else { //Otherwise run right away
				restorePosition();
			}

			//save scroll position on change
			scope.$on("$routeChangeStart", function () {
				scope.$eval(attrs.ngKeepScroll + " = " + $(window).scrollTop());
			});

			function restorePosition() {
				$timeout(function () {
					//load scroll position after everything has rendered
					var scrollY = parseInt(scope.$eval(attrs.ngKeepScroll));
					$(window).scrollTop(scrollY ? scrollY : 0);
				});
			}
		};
	}])
	// .directive('ngCollapseOnRouteChange', [
	// 	function () {
	// 		return function (scope, element, attrs) {
	// 			scope.$on("$routeChangeSuccess", function () {
	// 				if (element.css('display') !== 'none')
	// 					element.collapse('hide');
	// 			});
	// 		};
	// 	}
	// ])
	.filter('moment', function () {
		return function (m, format) {
			var result = 'not a moment';
			if (m && m._isAMomentObject) {

				if (format === 'datetime')
					result = m.format('YYYY-MM-DD HH:mm:ss')
				else
					result = m.format('YYYY-MM-DD')
			}
			return result;
		}
	});


(function () {
	var now = new Date();
	var logoutTime = new Date(now.toDateString());
	logoutTime.setHours(3);

	if (now.getHours() > 3) {
		logoutTime.setDate(now.getDate() + 1);
	}

	setInterval(function () {
		if (new Date() > logoutTime) {
			window.location = window.QuickShopSettings.logoutUrl;
		}
	}, 60000);
})();
